import styled from 'styled-components'

export default styled.section`
    .paragraph-section {
        padding-top: 5rem;
        padding-bottom: 2rem;
        @media (max-width: ${props => props.theme.breakpoints.tablet}) {
            padding-bottom: 1rem;
        }
    }

`